import { FunctionComponent } from 'react';

interface ILoadingProps {
}

const Loading: FunctionComponent<ILoadingProps> = (props) => {

  return <div>
      loading...
  </div>;
};

export default Loading;
